module.exports = __webpack_public_path__ + "static/media/img-modal-nro-serie.ba21a3df.png";